import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";

export default function Currency({ setCurrnencyTobeConverted }) {
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState(""); // default no selection
    const [allcurrency, setallcurrency] = useState([
        { countryName: "United States", countryCode: "US", currencyCode: "USD", currencySymbol: "$" },
        { countryName: "Germany", countryCode: "DE", currencyCode: "EUR", currencySymbol: "€" },
        { countryName: "India", countryCode: "IN", currencyCode: "INR", currencySymbol: "₹" },
        { countryName: "United Kingdom", countryCode: "GB", currencyCode: "GBP", currencySymbol: "£" },
        { countryName: "Australia", countryCode: "AU", currencyCode: "AUD", currencySymbol: "$" },
        { countryName: "Canada", countryCode: "CA", currencyCode: "CAD", currencySymbol: "$" },
        { countryName: "Russia", countryCode: "RU", currencyCode: "RUB", currencySymbol: "₽" },
        { countryName: "South Korea", countryCode: "KR", currencyCode: "KRW", currencySymbol: "₩" },
        { countryName: "Brazil", countryCode: "BR", currencyCode: "BRL", currencySymbol: "$" },
        { countryName: "Japan", countryCode: "JP", currencyCode: "JPY", currencySymbol: "¥" },
        { countryName: "Indonesia", countryCode: "ID", currencyCode: "IDR", currencySymbol: "Rp" }
    ]);

    const filteredCurrencies = allcurrency?.filter((curr) => {
        const searchLower = searchQuery.toLowerCase();
        return (
            curr.currencySymbol.toLowerCase().includes(searchLower) ||
            curr.countryCode.toLowerCase().includes(searchLower) ||
            curr.countryName.toLowerCase().includes(searchLower) ||
            curr.currencyCode.toLowerCase().includes(searchLower)
        );
    });

    useEffect(() => {
        const array = [...allcurrency].sort((a, b) => a.currencyCode.localeCompare(b.currencyCode));
        setallcurrency(array);
    }, []);

    const handleChange = (curr) => {
        setCurrnencyTobeConverted(curr.currencyCode, curr.currencySymbol);
        setSelectedCurrency(curr.currencyCode);
    };

    return (
        <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                <strong className="d-flex align-items-center gap-2">{selectedCurrency ? selectedCurrency : "Select Currency"} <i class="fa-solid fa-angle-down"></i></strong>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item disabled className={!selectedCurrency ? 'active' : ''}>
                    Select Currency
                </Dropdown.Item>

                {filteredCurrencies?.map((curr, idx) => {
                    return (
                        <Dropdown.Item
                            className={curr.currencyCode === selectedCurrency ? 'active' : ''}
                            onClick={() => handleChange(curr)}
                            key={idx}
                            href="#"
                        >
                            {curr.currencySymbol} {curr.currencyCode}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
}
